import { getSignedUrl } from '../services/api';

export const openSignedUrl = async (key) => {
    if (!key) return;

    if (process.env.REACT_APP_STORAGE_TYPE !== 's3') {
        const url = `${process.env.REACT_APP_NODE_BASE_URL}/uploads/${key}`;
        window.open(url, '_blank');
        return;
    }

    try {
        const res = await getSignedUrl(key);
        window.open(res.data.url, '_blank');
    } catch (error) {
        console.error('Failed to get signed URL:', error);
    }
};

export const fetchSignedUrl = async (key) => {
    if (!key) return null;

    console.log('Fetching :', process.env.REACT_APP_STORAGE_TYPE);

    if (process.env.REACT_APP_STORAGE_TYPE !== 's3') {
        return `${process.env.REACT_APP_NODE_BASE_URL}/uploads/${key}`;
    }

    try {
        const res = await getSignedUrl(key);
        return res.data.url
    } catch (error) {
        console.error('Failed to get signed URL:', error);
        return null;
    }
};
